function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-168 -447) translate(48 198) translate(120 250)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8D03",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M17.778 11.111L1.111 11.111 6.667 0 33.333 0 38.889 11.111 22.222 11.111"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8D03",
  strokeWidth: 2,
  d: "M0 20L40 20"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8D03",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M22.222 15.556L40 15.556M0 15.556L17.778 15.556"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9.444,
  cy: 5.556,
  fill: "#FF8D03",
  fillRule: "nonzero",
  rx: 1.667,
  ry: 1.111
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.556,
  cy: 5.556,
  fill: "#FF8D03",
  fillRule: "nonzero",
  rx: 1.667,
  ry: 1.111
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8D03",
  strokeWidth: 2,
  d: "M22.222 0L22.222 20M17.778 20L17.778 0M17.778 3.333c-1.345.534-2.222 1.323-2.222 2.223 0 .9.877 1.688 2.222 2.222M22.222 7.778c1.345-.534 2.222-1.322 2.222-2.222 0-.9-.877-1.69-2.222-2.223"
})))));

var SvgIconMoney = function SvgIconMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-money.a5fa3c04.svg";
export { ForwardRef as ReactComponent };